import { render, staticRenderFns } from "./AddChaptersModal.vue?vue&type=template&id=50f2dc09&scoped=true&"
import script from "./AddChaptersModal.vue?vue&type=script&lang=js&"
export * from "./AddChaptersModal.vue?vue&type=script&lang=js&"
import style0 from "./AddChaptersModal.vue?vue&type=style&index=0&id=50f2dc09&prod&lang=scss&"
import style1 from "./AddChaptersModal.vue?vue&type=style&index=1&id=50f2dc09&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f2dc09",
  null
  
)

export default component.exports